/**
 * 生成目标结点的 pathInfo
 */ import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
export function generatePathInfo(target) {
    var _loop = function() {
        // 当 iterator 为 form 的时候。 tagName 可能获取到 HTML element
        // <form><input id="tagName" /></form>
        // form.tagName === input
        var tn = iterator.tagName;
        var tagName = // eslint-disable-next-line no-nested-ternary
        typeof tn === "string" ? tn.toLocaleLowerCase() : _instanceof(iterator, HTMLFormElement) ? "form" : "unknown";
        reversedTagNameArray.push(tagName);
        reversedDOMArray.push(iterator);
        if (!stopGenerateXpath) {
            var id = iterator.id;
            if (id && iterator !== document.body && iterator !== document.documentElement) {
                reversedXPathArray.push('/*[@id="'.concat(id, '"]'));
                stopGenerateXpath = true;
            }
            if (iterator.parentElement) {
                var children = Array.prototype.slice.apply(iterator.parentElement.children).filter(function(e) {
                    return e.tagName.toLocaleLowerCase() === tagName;
                });
                if (children.length > 1) {
                    tagName = "".concat(tagName, "[").concat(children.indexOf(iterator) + 1, "]");
                }
            }
            if (!stopGenerateXpath) {
                reversedXPathArray.push(tagName);
            }
        }
        iterator = iterator.parentElement;
    };
    var reversedDOMArray = [];
    var reversedXPathArray = [];
    var reversedTagNameArray = [];
    var iterator = target;
    var stopGenerateXpath = false;
    while(iterator)_loop();
    return {
        reversedXPathArray: reversedXPathArray,
        reversedDOMArray: reversedDOMArray,
        xpath: getXPathFromReversedXPathArray(reversedXPathArray),
        reversedTagNameArray: reversedTagNameArray
    };
}
export function getXPathFromReversedXPathArray(reversedXPathArray) {
    var array = [].concat(reversedXPathArray);
    return "/".concat(array.reverse().join("/"));
}
export function generatePathInfoWithDescendant(target, param) {
    var reversedDOMArray = param.reversedDOMArray, reversedXPathArray = param.reversedXPathArray, reversedTagNameArray = param.reversedTagNameArray;
    var index = reversedDOMArray.indexOf(target);
    if (index !== -1) {
        var end = index + 1;
        var xpathArray = reversedXPathArray.slice(0, end);
        return {
            reversedDOMArray: reversedDOMArray.slice(0, end),
            reversedTagNameArray: reversedTagNameArray.slice(0, end),
            reversedXPathArray: xpathArray,
            xpath: getXPathFromReversedXPathArray(xpathArray)
        };
    } else {
        return generatePathInfo(target);
    }
}

 //# sourceMappingURL=traverse.js.map